import store from '../store';
import router from '../router';
import routerHelper from './router-helper';
import notificator from './notificator';

let isInit = false;
let socket = null;
let socketStatusInterval = null;

const socketManager = {
  isInit() {
    return isInit;
  },
  init(route) {
    if (!socket) {
      socket = io.connect(process.env.VUE_APP_SOCKET_URL);
    }

    if (socket && socket.disconnected) {
      socket.connect();
    }

    if (isInit) return false;

    isInit = true;

    initSocketStatusPolling();
    initEventHandlers(route);

    return true;
  },
  emitUpdateToken(token) {
    socket.emit('updateToken', token);
  },
  emitRecreateGame(oldRoomId, newRoomId) {
    socket.emit('recreateGame', oldRoomId, newRoomId);
  },
  emitJoinRoom(roomId) {
    socket.emit('joinRoom', roomId);
  },
  emitLeaveRoom(roomId) {
    socket.emit('leaveRoom', roomId);
  },
  emitProposeTeammate(roomId, playerId) {
    socket.emit('proposeTeammate', roomId, playerId);
  },
  emitClearProposedTeam(roomId) {
    socket.emit('clearProposedTeam', roomId);
  },
  emitProposeExecutionTarget(roomId, playerId) {
    socket.emit('proposeExecutionTarget', roomId, playerId);
  },
  emitFetchState(roomId) {
    socket.emit('stateChange', roomId);
  },
  emitFetchMessages(roomId) {
    socket.emit('fetchMessages', roomId);
  },
  emitSendMessage(roomId, message) {
    socket.emit('sendMessage', roomId, message);
  },
};

function initSocketStatusPolling() {
  clearInterval(socketStatusInterval);

  socketStatusInterval = setInterval(() => {
    store.commit('socket/setIsConnected', socket && socket.connected);
  }, 1000);
}

function initEventHandlers(route) {
  socket.on('requestAuth', (payload, acknowledge) => {
    const token = localStorage.getItem('token');

    let roomId;
    if (route.name === 'lobby') {
      roomId = 'lobby';
    } else if (route.name === 'game') {
      roomId = route.params.id;
    }

    acknowledge(token, roomId);
  });

  socket.on('fetchGameState', (payload, acknowledge) => {
    acknowledge();

    store.dispatch('fetchGameState', payload.roomId);
  });

  socket.on('fetchNodeState', (payload, acknowledge) => {
    acknowledge();

    store.dispatch('applyNodeState', payload);
  });

  socket.on('fetchMessages', (payload, acknowledge) => {
    acknowledge();

    store.dispatch('chat/applyMessages', payload);
  });

  socket.on('fetchRoomUsers', (payload, acknowledge) => {
    acknowledge();

    store.dispatch('socket/applyRoomUsers', payload.roomUsers);
  });

  socket.on('recreateGame', (payload, acknowledge) => {
    acknowledge();

    const roomId = router.app.$root.$route.params.id;

    socketManager.emitLeaveRoom(roomId);

    const url = routerHelper.generateFullPath({
      name: 'game',
      params: { id: payload.roomId },
    });

    window.location.replace(url);
  });

  socket.on('messageReceived', (message, acknowledge) => {
    acknowledge();

    store.commit('chat/addMessage', message);
  });

  socket.on('logOut', (_, acknowledge) => {
    acknowledge();

    store.dispatch('auth/logOut');

    notificator.warn('Someone else has logged in with the same account.', 5000);
  });

  socket.on('connect', () => {
    store.commit('socket/setIsConnected', socket.connected);
  });

  socket.on('disconnect', () => {
    store.commit('socket/setIsConnected', socket.connected);
  });
}

export default socketManager;
